/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from "flowbite-react";
import type { FC } from "react";
import { HiChevronLeft } from "react-icons/hi";

const MaintenancePage: FC = function () {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center py-16 mt-[-50px]">
      <img
        alt=""
        src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/undermaintaince.png"
        className="lg:max-w-md"
      />
      <h1 className="mt-6 mb-3 text-center text-4xl font-medium font-['Inter'] dark:text-white whitespace-nowrap">
        This feature is under construction
      </h1>
      <div className="flex items-center justify-center whitespace-nowrap">
        <p className="text-center">
          <span className="text-gray-400 text-xl font-normal font-['Inter']">We are constantly working to build the</span>
          {' '}
          <span className="text-blue-600 text-xl font-normal font-['Inter']">best for you :)</span>
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
